export class StudentQRCode {
  firstName: string;
  lastName: string;
  qrCode: string;
  studentUserName: string;
  userId: string;
  userName: string;
  schoolName: string;
}
